import { render, staticRenderFns } from "./RecentActivityTableDescriptionBookingPaid.vue?vue&type=template&id=4506d9cc&"
import script from "./RecentActivityTableDescriptionBookingPaid.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionBookingPaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports